// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6900a2ef","990":"176e26cc"}[chunkId] + ".chunk.js";
};